import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M0 0h48v48H0z"
}), React.createElement("path", {
  d: "M2 48v-2c1.333 0 2-.667 2-2h2V4H4c0-1.273-.607-1.938-1.822-1.996L2 2V0h44v2c-1.273 0-1.938.607-1.996 1.822L44 4h-2v40h2c0 1.333.667 2 2 2v2H2zm20-22H10v18h12V26zm16 0H26v18h12V26zm0-22H26v18h12V4zM22 4H10v18h12V4z",
  fill: "#262626"
}));

var SvgAddOnWindowsXLarge = function SvgAddOnWindowsXLarge(props) {
  return React.createElement("svg", props, _ref);
};

export default SvgAddOnWindowsXLarge;